import { toLatinDigits, toPersianDigits } from './digits.js';

const E164 = /^\+[1-9][0-9]{7,14}$/;

export function isE164(value: string): boolean {
  return E164.test(value);
}

/**
 * Normalizes an Iranian mobile number to E.164 (BR-22).
 * Accepts Persian/Arabic digits and separators; `09124451102`, `9124451102`,
 * `989124451102`, `00989124451102` and `+989124451102` all map to `+989124451102`.
 * Returns null when the input is not an Iranian mobile number.
 */
export function normalizeIranMobile(raw: string): string | null {
  const cleaned = toLatinDigits(raw).replace(/[\s\-().]/g, '');
  if (!/^\+?[0-9]+$/.test(cleaned)) return null;
  let national: string;
  if (cleaned.startsWith('+98')) national = cleaned.slice(3);
  else if (cleaned.startsWith('0098')) national = cleaned.slice(4);
  else if (cleaned.startsWith('98') && cleaned.length === 12) national = cleaned.slice(2);
  else if (cleaned.startsWith('0')) national = cleaned.slice(1);
  else national = cleaned;
  if (!/^9[0-9]{9}$/.test(national)) return null;
  return `+98${national}`;
}

/** `+989124451102` → `۰۹۱۲ ۴۴۵ ۱۱۰۲` for display. Other E.164 numbers are shown unchanged. */
export function formatIranMobile(e164: string): string {
  const match = /^\+98(9\d{2})(\d{3})(\d{4})$/.exec(e164);
  if (!match) return e164;
  return toPersianDigits(`0${match[1]} ${match[2]} ${match[3]}`);
}
